import * as React from 'react';
import { Button, Col, Form, Modal, ModalProps, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { normalizeVersion } from './utils';

type Props = {
  loading: boolean;
  onAdd: (version: string, forceUpdateType: string, platform: string) => void;
} & ModalProps;

const CreateVersionConfigModal = ({ show, onHide, onAdd, loading }: Props) => {
  const [type, setType] = React.useState('optional');
  const [platform, setPlatform] = React.useState('all');
  const [version, setVersion] = React.useState('003.013.000');

  const handleSubmit = () => {
    const normalizedVersion = normalizeVersion(version);
    if (normalizedVersion.length !== 11) {
      alert('Please, enter valid version');
      return;
    }
    onAdd(normalizedVersion, type, platform);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-plus-circle mr-2" />
          Add NVS Campaign
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mt-2">
          <Col xs={3}>
            <span>Version</span>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="nvs-version-tooltip">This is the NVS target version.</Tooltip>}
            >
              <i className="fas fa-info-circle ml-2 text-muted" />
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="nvs-version-format-tooltip">Use version format: 003.013.000</Tooltip>}
            >
              <i className="fas fa-question-circle ml-2 text-muted" />
            </OverlayTrigger>
          </Col>
          <Col xs={6}>
            <Form.Control
              name="version"
              required
              type="text"
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              onBlur={(event: React.FocusEvent<HTMLInputElement>) =>
                setVersion(normalizeVersion(event.target.value))
              }
            />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={3}>Platform</Col>
          <Col xs={6}>
            {/* @ts-ignore */}
            <Form.Control
              required
              name="type"
              as="select"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
            >
              {['all', 'ios', 'android'].map((optionType) => (
                <option value={optionType} key={optionType}>
                  {optionType}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={3}>Type</Col>
          <Col xs={6}>
            {/* @ts-ignore */}
            <Form.Control required name="type" as="select" value={type} onChange={(e) => setType(e.target.value)}>
              {['optional', 'mandatory'].map((optionType) => (
                <option value={optionType} key={optionType}>
                  {optionType}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Row>
        <Modal.Footer className="px-0">
          <Button disabled={loading} onClick={handleSubmit}>
            Create
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default CreateVersionConfigModal;
